import React from 'react'
import { useTheme } from '@/context/ThemeContext'
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'
import { TimeWindow } from '../askAnything/chatStore'

type TimeWindowSelectProps = {
  value: TimeWindow
  onChange: (value: TimeWindow) => void
}

export const TimeWindowSelect: React.FC<TimeWindowSelectProps> = ({ value, onChange }) => {
  const { isDarkMode } = useTheme()

  // Options shown inside the dropdown (long labels)
  const dropdownOptions = [
    { value: TimeWindow.THIRTY_DAYS, label: 'Last 30 Days' },
    { value: TimeWindow.NINETY_DAYS, label: 'Last 90 Days' },
    { value: TimeWindow.PAST_YEAR, label: 'Past Year' },
    { value: TimeWindow.ALL_TIME, label: 'All Time' },
  ]

  // Short labels for the closed state
  const shortLabels: Record<TimeWindow, string> = {
    [TimeWindow.THIRTY_DAYS]: '30D',
    [TimeWindow.NINETY_DAYS]: '90D',
    [TimeWindow.PAST_YEAR]: '1Y',
    [TimeWindow.ALL_TIME]: 'ALL',
  }

  const getShortLabel = (value: TimeWindow) => shortLabels[value] || '90D'

  return (
    <div className="flex items-center">
      <Select value={value} onValueChange={(val) => onChange(val as TimeWindow)}>
        <SelectTrigger
          id="feedbackFocus"
          className={`px-1 py-0.5 h-auto border-0 bg-transparent font-semibold text-sm cursor-pointer focus:outline-none focus:ring-0 focus:border-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-0 [&_svg]:hidden justify-start hover:bg-gray-200 dark:hover:bg-gray-700 rounded text-gray-500 dark:text-gray-400 shadow-none outline-none`}
        >
          <span>{getShortLabel(value as TimeWindow)}</span>
        </SelectTrigger>
        <SelectContent align="start" className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : ''} text-sm`}>
          {dropdownOptions.map((option) => (
            <SelectItem key={option.value} value={option.value} className="text-sm">
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
